import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  IconButton,
  InputAdornment,
  Alert,
  Paper,
  Divider,
  Link,
  Slide,
  LinearProgress,
} from "@mui/material";
import AlertaContext from "../../Context/Alerta/AlertaContext";
import AuthContext from "../../Context/Auth/AuthContext";
import {
  VisibilityOff,
  Visibility,
  Person,
  Business,
  Lock,
  Shield,
  ChevronRight,
  ArrowBack,
} from "@mui/icons-material";
import imgLogoNeitor from "../../assets/img/sigeoplogo.png";
import imgFondo from "../../assets/img/bg.jpg";
import dash1 from "../../assets/img/dashboard/1.jpeg";
import dash2 from "../../assets/img/dashboard/2.jpeg";
import dash3 from "../../assets/img/dashboard/3.jpeg";
import dash4 from "../../assets/img/dashboard/4.jpeg";
import dash5 from "../../assets/img/dashboard/5.jpeg";
import dash6 from "../../assets/img/dashboard/6.jpeg";
import dash7 from "../../assets/img/dashboard/7.jpeg";
import dash8 from "../../assets/img/dashboard/8.jpeg";
import clienteAxios from "../../config/axios";

const sliderImages = [
  imgFondo,
  dash1,
  dash2,
  dash3,
  dash4,
  dash5,
  dash6,
  dash7,
  dash8,
];

const policyLinks = [
  {
    key: "checkPolitica",
    label: "Política de Protección",
    href: "https://f005.backblazeb2.com/file/neitor/politicas_sincop/POLITICA_DE_PROTECCION_DE_DATOS_PERSONALES_SINCOP.pdf",
  },
  {
    key: "checkTerminos",
    label: "Términos y Condiciones",
    href: "https://f005.backblazeb2.com/file/neitor/politicas_sincop/TERMINOS_Y_CONDICIONES_DE_USO_DE_LA_PLATAFORMA_SINCOP.pdf",
  },
  {
    key: "checkComercio",
    label: "Política de Comercio Electrónico",
    href: "https://f005.backblazeb2.com/file/neitor/politicas_sincop/POLITICA_DE_COMERCIO_ELECTRONICO_Y_RELACIONES_LABORALES_DIGITALES_SINCOP.pdf",
  },
];

export default function Login(props) {
  const { alerta, mostrarAlerta } = useContext(AlertaContext);
  const { iniciarSesion, mensaje, autenticado } = useContext(AuthContext);
  const [check, setCheck] = useState(false);
  const [recuperarForm, setrecuperarForm] = useState({ email: "", empresa: "" });
  const [form, setform] = useState({ empresa: "", usuario: "", password: "" });
  const [verpass, setverpass] = useState(false);
  const { empresa, usuario, password } = form;
  const [recuperarContraseña, setrecuperarContraseña] = useState(false);
  const [checkPolitica, setCheckPolitica] = useState(
    localStorage.getItem("checkPolitica") === "true"
  );
  const [checkTerminos, setCheckTerminos] = useState(
    localStorage.getItem("checkTerminos") === "true"
  );
  const [checkComercio, setCheckComercio] = useState(
    localStorage.getItem("checkComercio") === "true"
  );
  const [politicasError, setPoliticasError] = useState(false);
  const [cargando, setcargando] = useState(false);
  const [sliderIndex, setSliderIndex] = useState(0);

  useEffect(() => {
    if (sliderImages.length <= 1) return;
    const interval = setInterval(() => {
      setSliderIndex((prev) => (prev + 1) % sliderImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const policyState = {
    checkPolitica,
    checkTerminos,
    checkComercio,
  };
  const policySetters = {
    checkPolitica: setCheckPolitica,
    checkTerminos: setCheckTerminos,
    checkComercio: setCheckComercio,
  };

  const handleCheck = (event) => {
    setCheck(event.target.checked);
    if (!event.target.checked) {
      setCheckPolitica(false);
      setCheckTerminos(false);
      setCheckComercio(false);
      localStorage.removeItem("checkPolitica");
      localStorage.removeItem("checkTerminos");
      localStorage.removeItem("checkComercio");
    }
  };

  const botonLogin = () => {
    return empresa.trim() !== "" && usuario.trim() !== "" && password.trim() !== "";
  };

  const handleChange = (e) => {
    setform({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!botonLogin()) {
      return mostrarAlerta("Los campos son obligatorios", "error");
    }
    if (!checkPolitica || !checkTerminos || !checkComercio) {
      setPoliticasError(true);
      return mostrarAlerta(
        "Debes aceptar las políticas y términos para continuar",
        "error"
      );
    }

    if (check) {
      localStorage.setItem("checkPolitica", "true");
      localStorage.setItem("checkTerminos", "true");
      localStorage.setItem("checkComercio", "true");
    }
    iniciarSesion({ usuario: usuario.trim(), password, empresa, from: "web" });
    if (check) {
      localStorage.setItem("usuario", usuario);
      localStorage.setItem("password", password);
      localStorage.setItem("empresa", empresa);
      localStorage.setItem("recordar", true);
    } else {
      localStorage.setItem("usuario", "");
      localStorage.setItem("password", "");
      localStorage.setItem("empresa", "");
      localStorage.setItem("recordar", false);
    }
  };

  useEffect(() => {
    if (autenticado) {
      props.history.push("/Seguridad/Dashboard");
    }
    if (mensaje) {
      mostrarAlerta(mensaje.msg, mensaje.categoria);
    }
  }, [mensaje, autenticado]);

  useEffect(() => {
    const recordar = localStorage.getItem("recordar") === "true";
    setCheck(recordar);
    if (recordar) {
      const usuario = localStorage.getItem("usuario");
      const password = localStorage.getItem("password");
      const empresa = localStorage.getItem("empresa");
      setform({
        ...form,
        usuario: usuario || "",
        password: password || "",
        empresa: empresa || "",
      });
    }
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        background: "linear-gradient(180deg, #0076A7 0%, #0d2137 50%, #0f2b46 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          flex: { xs: 1, md: "0 0 520px", lg: "0 0 560px" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: { xs: 3, sm: 4 },
          position: "relative",
          zIndex: 1,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            maxWidth: 460,
            bgcolor: "transparent",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 4,
            }}
          >
            <img
              src={imgLogoNeitor}
              alt="logo"
              style={{
                maxWidth: 250, 
                filter: "drop-shadow(0 4px 12px rgba(20,82,148,0.3))",
              }}
            />
          </Box>

          {alerta && (
            <Alert
              severity={alerta.categoria}
              variant="filled"
              sx={{
                mb: 2,
                borderRadius: 2,
                "& .MuiAlert-message": { fontSize: "0.875rem" },
              }}
            >
              {alerta.msg}
            </Alert>
          )}

          {recuperarContraseña ? (
            <Slide direction="left" in mountOnEnter unmountOnExit>
              <Box>
                <Button
                  startIcon={<ArrowBack />}
                  onClick={() => setrecuperarContraseña(false)}
                  sx={{
                    color: "rgba(255,255,255,0.6)",
                    mb: 3,
                    textTransform: "none",
                    "&:hover": { color: "#fff" },
                  }}
                >
                  Volver al inicio de sesión
                </Button>
                <Typography
                  variant="h5"
                  sx={{ color: "#fff", fontWeight: 600, mb: 1 }}
                >
                  Recuperar Contraseña
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "rgba(255,255,255,0.5)", mb: 3 }}
                >
                  Ingresa tus datos para restablecer tu contraseña
                </Typography>
                <Box
                  component="form"
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  <TextField
                    variant="filled"
                    fullWidth
                    value={recuperarForm.empresa}
                    id="empresa-rec"
                    label="Empresa"
                    name="empresa"
                    autoComplete="empresa"
                    onChange={(e) =>
                      setrecuperarForm({
                        ...recuperarForm,
                        [e.target.name]: e.target.value.toUpperCase(),
                      })
                    }
                    sx={{
                      mb: 2,
                      "& .MuiFilledInput-root": {
                        bgcolor: "rgba(255,255,255,0.06)",
                        borderRadius: 1,
                        "&:before": { display: "none" },
                        "&:after": { borderColor: "#145294" },
                        "&:hover": { bgcolor: "rgba(255,255,255,0.09)" },
                      },
                      "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.5)" },
                      "& .MuiFilledInput-input": { color: "#fff" },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Business sx={{ color: "rgba(255,255,255,0.35)", fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    variant="filled"
                    fullWidth
                    value={recuperarForm.email}
                    id="email-rec"
                    label="Usuario"
                    name="email"
                    autoComplete="email"
                    onChange={(e) =>
                      setrecuperarForm({
                        ...recuperarForm,
                        [e.target.name]: e.target.value,
                      })
                    }
                    sx={{
                      mb: 3,
                      "& .MuiFilledInput-root": {
                        bgcolor: "rgba(255,255,255,0.06)",
                        borderRadius: 1,
                        "&:before": { display: "none" },
                        "&:after": { borderColor: "#145294" },
                        "&:hover": { bgcolor: "rgba(255,255,255,0.09)" },
                      },
                      "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.5)" },
                      "& .MuiFilledInput-input": { color: "#fff" },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Person sx={{ color: "rgba(255,255,255,0.35)", fontSize: 20 }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Button
                    onClick={async () => {
                      try {
                        setcargando(true);
                        const res = await clienteAxios.post("auth/password", {
                          usuario: recuperarForm.email,
                          empresa: recuperarForm.empresa,
                        });
                        setcargando(false);
                        mostrarAlerta(res?.data?.msg, "success");
                      } catch (error) {
                        setcargando(false);
                        mostrarAlerta("Hubo un error al recuperar", "error");
                      }
                    }}
                    disabled={cargando}
                    type="button"
                    variant="contained"
                    fullWidth
                    sx={{
                      py: 1.5,
                      textTransform: "none",
                      fontWeight: 600,
                      borderRadius: 1.5,
                      background: "linear-gradient(135deg, #145294 0%, #1a73e8 100%)",
                      boxShadow: "0 4px 20px rgba(20,82,148,0.4)",
                      "&:hover": {
                        background: "linear-gradient(135deg, #1a5fa8 0%, #2080f0 100%)",
                        boxShadow: "0 6px 24px rgba(20,82,148,0.5)",
                      },
                      "&.Mui-disabled": {
                        background: "rgba(255,255,255,0.1)",
                        color: "rgba(255,255,255,0.3)",
                      },
                    }}
                  >
                    {cargando ? "Enviando..." : "Recuperar Contraseña"}
                  </Button>
                </Box>
              </Box>
            </Slide>
          ) : (
            <Box component="form" noValidate onSubmit={handleSubmit}>
              <Typography
                variant="h5"
                sx={{ color: "#fff", fontWeight: 600, mb: 1 }}
              >
                Iniciar Sesión
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "rgba(255,255,255,0.5)", mb: 3 }}
              >
                Ingresa tus credenciales para continuar
              </Typography>

              <TextField
                variant="filled"
                fullWidth
                value={empresa}
                id="empresa"
                label="Código Empresa"
                name="empresa"
                color="primary"
                autoComplete="Código empresa"
                autoFocus
                onChange={(e) =>
                  setform({
                    ...form,
                    [e.target.name]: e.target.value.toUpperCase(),
                  })
                }
                sx={{
                  mb: 2,
                  "& .MuiFilledInput-root": {
                    bgcolor: "rgba(255,255,255,0.06)",
                    borderRadius: 1,
                    "&:before": { display: "none" },
                    "&:after": { borderColor: "#145294" },
                    "&:hover": { bgcolor: "rgba(255,255,255,0.09)" },
                  },
                  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.5)" },
                  "& .MuiFilledInput-input": { color: "#fff" },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Business sx={{ color: "rgba(255,255,255,0.35)", fontSize: 20 }} />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                variant="filled"
                fullWidth
                id="usuario"
                color="primary"
                label="Usuario"
                name="usuario"
                value={usuario}
                onChange={handleChange}
                autoComplete="usuario"
                sx={{
                  mb: 2,
                  "& .MuiFilledInput-root": {
                    bgcolor: "rgba(255,255,255,0.06)",
                    borderRadius: 1,
                    "&:before": { display: "none" },
                    "&:after": { borderColor: "#145294" },
                    "&:hover": { bgcolor: "rgba(255,255,255,0.09)" },
                  },
                  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.5)" },
                  "& .MuiFilledInput-input": { color: "#fff" },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Person sx={{ color: "rgba(255,255,255,0.35)", fontSize: 20 }} />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                type={verpass ? "text" : "password"}
                variant="filled"
                fullWidth
                name="password"
                label="Contraseña"
                id="password"
                value={password}
                onChange={handleChange}
                autoComplete="current-password"
                sx={{
                  mb: 2,
                  "& .MuiFilledInput-root": {
                    bgcolor: "rgba(255,255,255,0.06)",
                    borderRadius: 1,
                    "&:before": { display: "none" },
                    "&:after": { borderColor: "#145294" },
                    "&:hover": { bgcolor: "rgba(255,255,255,0.09)" },
                  },
                  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.5)" },
                  "& .MuiFilledInput-input": { color: "#fff" },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Lock sx={{ color: "rgba(255,255,255,0.35)", fontSize: 20 }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setverpass(!verpass)}
                        edge="end"
                        size="small"
                        sx={{ color: "rgba(255,255,255,0.35)" }}
                      >
                        {verpass ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={check}
                      onChange={handleCheck}
                      name="recordar"
                      size="small"
                      sx={{
                        color: "rgba(255,255,255,0.35)",
                        "&.Mui-checked": { color: "#1a73e8" },
                      }}
                    />
                  }
                  label={
                    <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.6)" }}>
                      Recuérdame
                    </Typography>
                  }
                />
                <Button
                  onClick={() => setrecuperarContraseña(true)}
                  sx={{
                    color: "#5ba3e6",
                    textTransform: "none",
                    fontSize: "0.8rem",
                    "&:hover": { color: "#7bb8f0", bgcolor: "transparent" },
                  }}
                >
                  ¿Olvidaste tu contraseña?
                </Button>
              </Box>

              <Divider
                sx={{
                  borderColor: "rgba(255,255,255,0.08)",
                  mb: 2,
                }}
              />

              <Box sx={{ mb: 2.5 }}>
                {policyLinks.map((policy) => (
                  <FormControlLabel
                    key={policy.key}
                    control={
                      <Checkbox
                        checked={policyState[policy.key]}
                        onChange={(e) => {
                          policySetters[policy.key](e.target.checked);
                          if (e.target.checked) setPoliticasError(false);
                        }}
                        name={policy.key}
                        size="small"
                        sx={{
                          color: politicasError && !policyState[policy.key]
                            ? "#ef5350"
                            : "rgba(255,255,255,0.35)",
                          "&.Mui-checked": { color: "#1a73e8" },
                        }}
                      />
                    }
                    label={
                      <Link
                        href={policy.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="hover"
                        sx={{
                          fontSize: "0.75rem",
                          color: politicasError && !policyState[policy.key]
                            ? "#ef5350"
                            : "#5ba3e6",
                          "&:hover": {
                            color: politicasError && !policyState[policy.key]
                              ? "#ef5350"
                              : "#7bb8f0",
                          },
                        }}
                      >
                        {policy.label}
                      </Link>
                    }
                    sx={{
                      mx: 0,
                      my: -0.5,
                      "& .MuiFormControlLabel-label": { lineHeight: 1.3 },
                    }}
                  />
                ))}
              </Box>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                endIcon={<ChevronRight />}
                sx={{
                  py: 1.5,
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.95rem",
                  borderRadius: 1.5,
                  background: botonLogin()
                    ? "linear-gradient(135deg, #145294 0%, #1a73e8 100%)"
                    : "rgba(255,255,255,0.08)",
                  boxShadow: botonLogin()
                    ? "0 4px 20px rgba(20,82,148,0.4)"
                    : "none",
                  color: botonLogin() ? "#fff" : "rgba(255,255,255,0.3)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: botonLogin()
                      ? "linear-gradient(135deg, #1a5fa8 0%, #2080f0 100%)"
                      : "rgba(255,255,255,0.12)",
                    boxShadow: botonLogin()
                      ? "0 6px 24px rgba(20,82,148,0.5)"
                      : "none",
                  },
                }}
              >
                Iniciar Sesión
              </Button>
            </Box>
          )}
        </Paper>
      </Box>

      <style>{`@keyframes kenBurns{0%{transform:scale(1)}100%{transform:scale(1.08)}}`}</style>
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          flex: 1,
          position: "relative",
          overflow: "hidden",
        }}
      >
        {sliderImages.map((img, i) => {
          const isActive = i === sliderIndex;
          const isAdjacent =
            i === (sliderIndex + 1) % sliderImages.length ||
            i === (sliderIndex - 1 + sliderImages.length) % sliderImages.length;
          if (!isActive && !isAdjacent) return <Box key={i} />;
          return (
            <Box
              key={i}
              sx={{
                position: "absolute",
                inset: 0,
                opacity: isActive ? 1 : 0,
                transition: "opacity 1.2s ease-in-out",
                "&.kenBurnsActive": {
                  animation: "kenBurns 8s ease-in-out forwards",
                },
              }}
              className={isActive ? "kenBurnsActive" : ""}
            >
              <Box
                component="img"
                src={img}
                alt=""
                draggable={false}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  display: "block",
                  transform: isActive ? "scale(1.06)" : "scale(1)",
                  transition: "transform 8s ease-in-out",
                  filter: "brightness(0.95)",
                }}
              />
            </Box>
          );
        })}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(135deg, rgba(10,22,40,0.6) 0%, rgba(13,33,55,0.4) 100%)",
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            p: 6,
          }}
        >
          <Box sx={{ textAlign: "center", maxWidth: 480 }}>
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: "20px",
                background: "linear-gradient(135deg, #145294 0%, #1a73e8 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "auto",
                mb: 4,
                boxShadow: "0 8px 32px rgba(20,82,148,0.4)",
              }}
            >
              <Shield sx={{ fontSize: 40, color: "#fff" }} />
            </Box>
            <Typography
              variant="h3"
              sx={{
                color: "#fff",
                fontWeight: 700,
                mb: 2,
                fontSize: { md: "2.2rem", lg: "2.5rem" },
              }}
            >
              Bienvenido
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: "rgba(255,255,255,0.6)",
                fontWeight: 400,
                lineHeight: 1.6,
              }}
            >
              Ingresa tus credenciales para acceder a la plataforma
            </Typography>
          </Box>
        </Box>
        {sliderImages.length > 1 && (
          <Box
            sx={{
              position: "absolute",
              bottom: 32,
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: 1,
              zIndex: 3,
            }}
          >
            {sliderImages.map((_, i) => (
              <Box
                key={i}
                onClick={() => setSliderIndex(i)}
                sx={{
                  width: i === sliderIndex ? 24 : 8,
                  height: 8,
                  borderRadius: 4,
                  bgcolor: i === sliderIndex ? "#fff" : "rgba(255,255,255,0.35)",
                  cursor: "pointer",
                  transition: "all 0.4s ease",
                  "&:hover": {
                    bgcolor: i === sliderIndex ? "#fff" : "rgba(255,255,255,0.55)",
                  },
                }}
              />
            ))}
          </Box>
        )}
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: "-50%",
          right: "-20%",
          width: "60%",
          height: "100%",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(26,115,232,0.06) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "-30%",
          left: "-10%",
          width: "40%",
          height: "80%",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(20,82,148,0.05) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />
    </Box>
  );
}
